/**
 *
 * 项目配置
 */

import system from './system'
import cookie from './cookie'

export default {
  system,
  cookie
}
